export const userDetailSegmentState = {
	userDirectTunnelStatus: null,
	copyButtonColor: "black"
}
